"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactAutocomplete = _interopRequireDefault(require("react-autocomplete"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _label = _interopRequireDefault(require("./label"));

var _errorMessage = _interopRequireDefault(require("./error-message"));

var _field = require("./field");

var _textfield = _interopRequireDefault(require("./textfield.scss"));

var _autocomplete = _interopRequireDefault(require("./autocomplete.scss"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Autocomplete = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Autocomplete, _Component);

  function Autocomplete() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Autocomplete);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Autocomplete)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      value: _this.props.value
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "shouldItemRender", function (field) {
      return function (state, value) {
        return state[field].toLowerCase().indexOf(value.toLowerCase()) !== -1;
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (event, value) {
      _this.setState({
        value: value
      });

      if (_this.props.onChange) {
        _this.props.onChange(value);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSelect", function (value, item) {
      _this.setState({
        value: value
      });

      if (_this.props.onSelect) {
        _this.props.onSelect(item);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getLabel", function (item) {
      return item.label;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderMenu", function (items, value, style) {
      if (items.length === 0) {
        return _react["default"].createElement("div", {
          className: (0, _classnames["default"])(_autocomplete["default"].AutocompleteMenu, _autocomplete["default"].disabled, _autocomplete["default"].AutocompleteItem, _autocomplete["default"])
        }, _this.props.noMatchLabel);
      }

      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_autocomplete["default"].AutocompleteMenu, _autocomplete["default"]),
        children: items
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderItem", function (item, isHighlighted) {
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_autocomplete["default"].AutocompleteItem, (0, _defineProperty2["default"])({}, _autocomplete["default"].highlightedItem, isHighlighted))
      }, item.label);
    });
    return _this;
  }

  (0, _createClass2["default"])(Autocomplete, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.value && prevProps.value !== this.props.value) {
        this.setState({
          value: this.props.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.props.id || (0, _field.makeIdString)();
      var hasOptions = this.props.options.length > 0;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_autocomplete["default"].Wrapper, _textfield["default"].Textfield, this.props.classNames.wrapper, (0, _defineProperty2["default"])({}, _autocomplete["default"].disabled, this.props.options.length === 0))
      }, _react["default"].createElement(_label["default"], {
        className: (0, _classnames["default"])(this.props.classNames.label, (0, _defineProperty2["default"])({}, _textfield["default"].errorLabel, this.props.errorMessage)),
        "for": id
      }, this.props.label), _react["default"].createElement(_reactAutocomplete["default"], {
        inputProps: {
          placeholder: this.props.placeholder,
          'aria-label': this.props.ariaLabel,
          id: id,
          name: this.props.name,
          className: (0, _classnames["default"])(_textfield["default"].field, (0, _defineProperty2["default"])({}, _textfield["default"].fieldInvalid, this.props.errorMessage), _autocomplete["default"].fieldWithCarrot, this.props.classNames.field)
        },
        value: this.state.value,
        getItemValue: this.props.getLabel || this.getLabel,
        renderItem: this.renderItem,
        renderMenu: this.renderMenu,
        items: this.props.options,
        shouldItemRender: this.shouldItemRender(this.props.shouldRenderItemField),
        onChange: this.onChange,
        onSelect: this.onSelect,
        wrapperProps: {
          className: (0, _classnames["default"])(_autocomplete["default"].AutocompleteWrapper, (0, _defineProperty2["default"])({}, _autocomplete["default"].AutocompleteWrapperCarrot, hasOptions), _textfield["default"].fieldIconContainer)
        }
      }), this.props.errorMessage && _react["default"].createElement(_errorMessage["default"], {
        message: this.props.errorMessage,
        className: this.props.classNames.errorMessage
      }));
    }
  }]);
  return Autocomplete;
}(_react.Component);

exports["default"] = Autocomplete;
Autocomplete.propTypes = _objectSpread({
  shouldRenderItemField: _propTypes["default"].string.isRequired,
  options: _propTypes["default"].array,
  placeholder: _propTypes["default"].string,
  getItemValue: _propTypes["default"].func,
  noMatchLabel: _propTypes["default"].string
}, _field.fieldPropTypes);
Autocomplete.defaultProps = {
  classNames: {},
  shouldRenderItemField: 'label',
  value: '',
  noMatchLabel: 'No matches found'
};